export default {
  loading: {
    id: 'bo_seller-homepage-loading',
    defaultMessage: 'Loading...',
  },
  opportunities: {
    id: 'bo_seller-homepage-opportunities',
    defaultMessage: 'Opportunities',
  },
  viewDetails: {
    id: 'bo_seller-homepage-opportunities-view_details',
    defaultMessage: 'View details',
  },
  smallEffort: {
    id: 'bo_seller-homepage-opportunities-view_details-small_effort',
    defaultMessage: '{count} quick wins',
  },
  cold: {
    id: 'bo_seller-homepage-opportunities-view_details-cold',
    defaultMessage: '{count} listings in trouble',
  },
  coldDescription: {
    id: 'bo_seller-homepage-opportunities-view_details-cold-description',
    defaultMessage:
      'Boost {count} BackBoxes by decreasing your prices by 2% or less',
  },
  backboxToBoost: {
    id: 'bo_seller-homepage-opportunities-view_details-bacbkoxToBoost',
    defaultMessage: '{count} BackBoxes to boost',
  },
  smallEffortAction: {
    id: 'bo_seller-homepage-opportunities-view_details-small_effort_action',
    defaultMessage:
      'Win {count} BackBoxes by decreasing your prices by an average of {threshold}%',
  },
  coldAction: {
    id: 'bo_seller-homepage-opportunities-view_details-cold_action',
    defaultMessage:
      'Win {count} BackBoxes by decreasing your prices by {threshold}% or less',
  },
  backboxToBoostAction: {
    id: 'bo_seller-homepage-opportunities-view_details-backbox_to_boost_action',
    defaultMessage: 'Boost {count} BackBoxes',
  },
  noActionsDescription: {
    id: 'bo_seller-homepage-opportunities-view_details-no_actions_description',
    defaultMessage: 'Nice work. Your items are priced to sell.',
  },
}
